import type { StorefrontSeoProductModel } from '@supply-mover-2-0/shared';
import { create } from 'zustand';

/**
 * PD-17174 — what the current page knows about itself that the head tags need
 * and the route alone cannot tell: the product a product page loaded, or that
 * a page turned out not to exist. Each entry carries the path it belongs to,
 * so StorefrontHead never applies one page's product (or 404) to the next
 * page the shopper opens.
 */
interface StorefrontHeadState {
	product: { path: string; value: StorefrontSeoProductModel } | null;
	notFoundPath: string | null;

	setProduct: (path: string, value: StorefrontSeoProductModel) => void;
	setNotFound: (path: string) => void;
	/** Forget what `path` reported, when its page unmounts. */
	clear: (path: string) => void;
}

export const useStorefrontHeadStore = create<StorefrontHeadState>((set) => ({
	product: null,
	notFoundPath: null,

	setProduct: (path, value) => set({ product: { path, value } }),
	setNotFound: (path) => set({ notFoundPath: path }),
	clear: (path) =>
		set((state) => ({
			product: state.product?.path === path ? null : state.product,
			notFoundPath: state.notFoundPath === path ? null : state.notFoundPath,
		})),
}));
